import PQueue from "p-queue";
import {has} from "lodash";
import {List} from "../contract/notion";

type Node = Omit<List, 'has_more' | 'next_cursor'>;

export interface Nodes {
  [key: string]: Node;
}

const bootstrap = (nodes: Nodes): any => {
  return class QueueClass {
    protected _nodes: Nodes = {};
    protected _queue: any = [];

    constructor() {
      this._nodes = nodes;
    }

    enqueue(run, options): void {
      let node: Node = null;
      let isCurrent: boolean = null;

      if (options.id) {
        node = Object.entries(this._nodes)
          .find(([id, node]) => id === options.id); // eslint-disable-line @typescript-eslint/no-unused-vars

        // check cache
        isCurrent = node && (
          (has(node, 'stale_time') && has(node, 'rendered_time')) &&
          (new Date(node.rendered_time).getTime() <= new Date(node.stale_time).getTime())
        );
      }

      if (!node || node && !isCurrent) this._queue.push(run);
    }

    dequeue(): void {
      return this._queue.shift();
    }

    get size(): number {
      return this._queue.length;
    }

    filter(options): any { // eslint-disable-line @typescript-eslint/no-unused-vars
      return this._queue;
    }
  }
}

type QueueDef = (nodes: Nodes, options: {[key: string]: any}) => PQueue;

export const queue: QueueDef = (
  nodes,
  options = { verbose: (process.env.NODE_ENV === 'development'), concurrency: 5 }
) => {
  const q = new PQueue({queueClass: bootstrap(nodes), concurrency: options.concurrency});

  if (options.verbose) {
    q.on('add', () => {
      console.log(`Task is added.  Size: ${q.size}  Pending: ${q.pending}`);
    });

    q.on('next', () => {
      console.log(`Task is completed.  Size: ${q.size}  Pending: ${q.pending}`);
    });
  }

  return q;
}
